import { ThemeProvider, ToastProvider } from '@vtex/admin-ui'
import { StrictMode } from 'react'
import type { DefaultProps } from 'typings'

export function BaseProviders(props: DefaultProps) {
  return (
    <StrictMode>
      <ThemeProvider>
        <ToastProvider>{props.children}</ToastProvider>
      </ThemeProvider>
    </StrictMode>
  )
}
